<template>
  <div class="bg-for-business">
  </div>
</template>

<style type="text/css" scoped>
  .bg-for-business {
    margin: -100px -20px -50px;
  }

  .img-business {
    background-image: url(../../assets/img/img-business.svg);
  }

  @media only screen and (max-width: 1279px) {
    .bg-for-business {
      margin: -50px -20px;
    }
  }

  @media screen and (max-width: 480px) {
    .bg-for-business {
      margin: -20px -20px -50px;
    }
  }
</style>

<script>
const wideSvg = require('!!raw-loader!../../assets/img/img-business.svg');
const mobSvg = require('!!raw-loader!../../assets/img/img-business-mob.svg');

export default {
  data() {
    return {}
  },
  created(){
  },

  mounted() {
    this.resize();
  },

  methods:{
    resize(){
      let vm = this;
      let svgW = $(wideSvg);
      let svgM = $(mobSvg);

      if($(window).width() < 750)
        svgM.appendTo(this.$el);
      else
        svgW.appendTo(this.$el);

    }
  }
}

</script>


// WEBPACK FOOTER //
// for-business.vue?349d84bc